import { useDeck } from '@/app/context/DeckContext/useDeck';
import * as React from 'react';
import Loader from '../loader/Loader';
import { useFeedback } from '@/app/context/FeedbackContext/useFeedback';
import { useAuth } from '@/app/context/AuthContext/useAuth';

const DownloadAnkiButton = ({ iconOnly, isLanding, onClick }) => {
  const { selectedDeckData, downloadAnkiPackage } = useDeck();

  const { submitFeedback } = useFeedback();
  const { user } = useAuth();

  const [isBuilding, setIsBuilding] = React.useState(false);

  const groups =
    selectedDeckData?.cards.reduce((prev, curr) => {
      for (const cardGroup of prev) {
        if (cardGroup.some((card) => card.question === curr.question)) {
          cardGroup.push(curr);
          return prev;
        }
      }

      prev.push([curr]);

      return prev;
    }, [] as any[][]) ?? [];

  const onDownloadClick = async () => {
    try {
      setIsBuilding(true);

      await downloadAnkiPackage();

      submitFeedback('Download Anki Success - ' + user.email);
    } catch (e) {
      submitFeedback(
        'Download Anki Failed - ' + user.email + ' - ' + e.toString()
      );
    }
    setIsBuilding(false);
  };

  return (
    <div
      onClick={isBuilding ? null : onDownloadClick}
      className="card min-h-44 max-w-md cursor-pointer border-b-4 border-solid border-transparent bg-base-300 text-primary-content shadow-lg lg:card-side hover:border-secondary"
    >
      <div className="card-body flex items-center justify-center">
        {isBuilding && (
          <div>
            <div className="mr-3 flex flex-row items-center justify-center gap-3">
              <div className="flex flex-row items-center justify-center gap-3">
                <Loader />
                <p className="text-center text-lg font-bold text-base-content">
                  Building Anki Package...
                </p>
              </div>
            </div>
          </div>
        )}
        {!isBuilding && (
          <div>
            <div className="mr-3 flex flex-row items-center justify-center gap-3">
              <div className="flex flex-row items-center justify-center gap-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  className="inline-block w-5 fill-base-content text-base-content"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path d="M3 19h18v2H3v-2zm10-5.828L19.071 7.1l1.414 1.414L12 17 3.515 8.515 4.929 7.1 11 13.17V2h2v11.172z" />
                </svg>
                <p className="text-center text-lg font-bold text-base-content">
                  Download Anki Package
                </p>
              </div>
            </div>

            <p className="pt-3 text-base-content">
              <b>{selectedDeckData?.cards.length ?? 0} occlusions</b> for{' '}
              <b>{groups.length} images</b>
            </p>
          </div>
        )}
      </div>
      <iframe id="download_frame" className="hidden"></iframe>
    </div>
  );
};

export default DownloadAnkiButton;
